/**
 * Format các giá trị
 */
export default {
  /**
   * Ngày
   */
  Date: 'YYYY-MM-DD',

  /**
   * Hiển thị ngày
   */
  DisplayDate: 'DD/MM/YYYY',

  /**
   * Hiển thị ngày không có giây
   */
  DateNotSecond: 'DD/MM/YYYY HH:mm',

  /**
  * Hiển thị thời gian không có giây
  */
  TimeNotSecond: 'HH:mm',
};
